import React, { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { Button } from "@mui/material";

const StatusFilterPopup = ({ isOpen, onClose, statusdata , onStatusSelect }) => {
    const [selectedStatus, setSelectedStatus] = useState(null); // Track selected status
  
    // Handle Status click (only for visual selection until apply is clicked)
    const handleStatusClick = (statusName) => {
      if (statusName === selectedStatus) {
        setSelectedStatus(null); // Deselect if it's already selected
      } else {
        setSelectedStatus(statusName); // Select the new status
      }
    };
  
    // Handle Apply Filters button click
    const handleApplyFilters = () => {
      if (selectedStatus) {
        onStatusSelect(selectedStatus); // Call the parent function to update status filter
      }
      onClose(); // Close the popup after applying the filter
    };
    const handleCloseStatus=()=>{
        setSelectedStatus(null); // Reset selected status to null
        onStatusSelect(null);
        onClose();
    }
  
    return (
      isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          {/* Popup Box */}
          <div className="relative flex flex-col gap-2 w-[28%] bg-white pb-2 p-3 rounded-lg shadow-lg text-left">
            <button
              className="absolute right-[5%] text-gray-500 hover:text-gray-700 text-[30px]"
              onClick={onClose}
            >
              <CloseIcon style={{ color: 'black', width: '18px' }} />
            </button>
  
            <div className="p-2">
              <div className="w-full flex items-center justify-between mt-2">
                {/* Title */}
                <span className="ml-2 font-inter text-[#1D2951] text-[16px] font-semibold text-center tracking-[0] leading-[normal] whitespace-nowrap">
                  Filter by Status
                </span>
              </div>
            </div>
  
            <div className="flex flex-column overflow-y-auto max-h-110 pb-2 border-b-2">
              {[...new Set(statusdata.filter((x,y)=>x.visit_confirmation!=='Checked Out').map(x => x.visit_confirmation))].filter(status => status).map((status, index) => {
                  // Define the base button classes
                  let buttonClass = "py-[10px] px-4 m-2 mr-3 text-xs font-inter ml-3 rounded-full transition";
                  
                  // Add the background color and text color based on the status
                  if (status === "Ready for Triage") {
                    buttonClass += " bg-[#F0FDF4] text-[#50869A]"; // Specific for "Ready for Triage"
                  } else if (status === "Ready for Provider") {
                    buttonClass += " bg-[#F3E8FF] text-[#9333EA]";
                  } else if (status === "Checked Out") {
                    buttonClass += " bg-[#E1795459] text-[#C2410C]";
                  } else if (status === "Processing") {
                    buttonClass += " bg-[#DBEAFE] text-[#1D4ED8]";
                  } else if (status === "Ready for Checkout") {
                    buttonClass += " bg-[#DBEAFE] text-[#1D4ED8]";
                  } else {
                    buttonClass += " bg-[#ECECEE] text-[#1D4ED8]"; // Default style
                  }
                  
                  // Add a selected class for the selected status
                  const selectedClass = selectedStatus === status ? "border-[1.5px] border-[#1D4ED8]" : "";
                  
                  return (
                    <button
                      key={index}
                      onClick={() => handleStatusClick(status)}
                      className={`${buttonClass} ${selectedClass}`}
                    >
                      {status} {/* Button text */}
                    </button>
                  );
                })
              }
            </div>
             <div className="p-2 px-4">
             {[...new Set(statusdata.filter((x) => x.visit_confirmation === 'Checked Out').map((x) => x.visit_confirmation))].map((status, index) => (
  <label key={index} className="text-[14px] font-inter flex items-center">
    <input
      type="checkbox"
      onChange={() => handleStatusClick(status)}
       className="cursor-pointer w-4 h-4 mr-1"
    />
    Checked All {/* Checkbox label */}
  </label>
))}


             </div>
            {/* Apply Filters Button */}
            <div className="w-full flex justify-between gap-6 mb-1 mt-3">
              {/* Clear All Filters Button */}
              <button
                className="rounded py-2 px-4 text-[13px] font-poppins px-2 transition duration-300 ease-in-out border-2 font-Font1 text-[black]"
                onClick={handleCloseStatus} // Clear the selected status
              >
                Clear All
              </button>
  
              <button
                onClick={handleApplyFilters}
                className={`rounded py-2 px-4 text-[12px] font-inter px-2 transition duration-300 ease-in-out bg-[black] text-[#FFFFFF]`}
              >
                Apply Filters
              </button>
            </div>
          </div>
        </div>
      )
    );
  };
  

export default StatusFilterPopup;
